import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Title, Text, Button, Loader } from '@mantine/core';
import { QrCode, RefreshCw } from 'lucide-react';
export function QRCodePage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleSuccess = () => {
    navigate('/dashboard');
  };
  const refreshQRCode = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1500);
  };
  return <div className="min-h-screen flex items-center justify-center bg-light p-4" data-id="element-533">
      <Paper radius="lg" p="xl" withBorder shadow="md" className="max-w-md w-full" data-id="element-534">
        <div className="text-center mb-6" data-id="element-535">
          <Title order={2} className="text-primary mb-2" data-id="element-536">
            Conecte seu WhatsApp
          </Title>
          <Text color="dimmed" size="sm" data-id="element-537">
            Escaneie o código QR com seu WhatsApp para conectar
          </Text>
        </div>
        <div className="bg-gray-100 rounded-lg p-4 mb-6 aspect-square flex items-center justify-center" data-id="element-538">
          {isLoading ? <Loader color="#0047AB" size="lg" data-id="element-539" /> : <div className="flex flex-col items-center" data-id="element-540">
              <QrCode size={180} className="text-primary mb-4" data-id="element-541" />
              <Text size="sm" color="dimmed" data-id="element-542">
                QR Code de exemplo
              </Text>
            </div>}
        </div>
        <div className="space-y-4" data-id="element-543">
          <Button fullWidth leftSection={<RefreshCw size={18} data-id="element-545" />} onClick={refreshQRCode} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #0047AB',
            color: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#E3F2FD'
            }
          }
        }} data-id="element-544">
            Atualizar código QR
          </Button>
          <Button fullWidth onClick={handleSuccess} radius="lg" styles={{
          root: {
            backgroundColor: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#003d91'
            }
          }
        }} data-id="element-546">
            Continuar para o Dashboard
          </Button>
          <Text size="xs" color="dimmed" className="text-center mt-4" data-id="element-547">
            Mantenha seu telefone próximo e com conexão à internet
          </Text>
        </div>
      </Paper>
    </div>;
}